export default __webpack_public_path__ + "static/favicon-008b9c79df7ceceb269cda8ad7425a79.png";